import { Close as CloseIcon } from '@mui/icons-material';
import { Dialog, DialogContent, IconButton, Box } from '@mui/material';

interface PopupProps {
  open: boolean;
  onClose: () => void;
  width?: number;
  height?: number;
  children: React.ReactNode;
}

export function Popup({
  open,
  onClose,
  width = 800,
  height = 600,
  children
}: PopupProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          backgroundColor: '#000',
          width: width,
          height: height,
          maxWidth: '90vw',
          maxHeight: '90vh',
        }
      }}
    >
      <Box sx={{ 
        position: 'absolute', 
        right: 8, 
        top: 8, 
        zIndex: 1 
      }}>
        <IconButton
          onClick={onClose}
          sx={{ 
            color: 'white',
            bgcolor: 'rgba(0, 0, 0, 0.5)',
            '&:hover': {
              bgcolor: 'rgba(0, 0, 0, 0.7)',
            }
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      
      <DialogContent sx={{ 
        p: 0, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        overflow: 'hidden'
      }}>
        {children}
      </DialogContent>
    </Dialog>
  );
} 